import React, { forwardRef, PropsWithChildren } from "react";
import OptionCard from "../OptionCard";

export type ToggleOptionCardGroupValue = any;

export type ToggleOptionCardGroupProps = {
  name?: string;
  value?: ToggleOptionCardGroupValue | ToggleOptionCardGroupValue[];
  onChange?: any;
  type?: "checkbox" | "radio";
  ref?: any;
  className?: string;
  label?: string;
};

const ToggleOptionCardGroup = forwardRef<
  HTMLDivElement | null,
  PropsWithChildren<ToggleOptionCardGroupProps>
>(function ToggleOptionCardGroup(
  { children, name, value, onChange, type = "radio", className, label },
  ref,
) {
  const getValues = () => (value == null ? [] : [].concat(value));
  const handleToggle = (inputVal: any, event: any) => {
    if (!onChange) {
      return;
    }

    const values: ToggleOptionCardGroupValue[] = getValues();
    const isActive = values.indexOf(inputVal) !== -1;

    if (type === "radio") {
      if (!isActive && onChange) onChange(inputVal, event);
      return;
    }

    if (isActive) {
      onChange(
        values.filter((n) => n !== inputVal),
        event,
      );
    } else {
      onChange([...values, inputVal], event);
    }
  };

  if (!Array.isArray(children)) {
    if (process.env.NODE_ENV === "production") {
      return null;
    }
    throw new Error("Invalid child elements, only an array of components");
  }

  return (
    <div ref={ref}>
      {label && <label className="block text-title-1 mb-2xs">{label}</label>}
      <div className={className}>
        {children.map((child) => {
          if (React.isValidElement(child)) {
            const values: ToggleOptionCardGroupValue[] = getValues();
            const props: any = child.props;
            const { value: childVal, onChange: childOnChange } = props;

            return React.cloneElement(child as React.ReactElement<any>, {
              checked: values.indexOf(childVal) !== -1,
              name: name,
              type: type,
              onChange: (e: any) => {
                handleToggle(childVal, e);
                if (childOnChange) {
                  childOnChange();
                }
              },
            });
          }
          return null;
        })}
      </div>
    </div>
  );
});

export default Object.assign(ToggleOptionCardGroup, {
  Option: OptionCard,
});
